import { useEffect } from "react";
import { CheckCircle2, Mail, Sparkles } from "lucide-react";
import { LeafMark } from "@/lib/site";

export default function ThankYou() {
  useEffect(() => {
    document.title = "Thank You — The Sustainable Tea & Weight Loss Method";
    const script = document.createElement("script");
    script.src = "https://checkout.hotmart.com/lib/hotmart-checkout-elements.js";
    script.async = true;
    script.onload = () => {
      if (window.checkoutElements) {
        window.checkoutElements.init("salesFunnel").mount("#hotmart-sales-funnel");
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#1C3A27] text-[#FAF7F2]" data-testid="thank-you-page">
      <header className="border-b border-[#D4A359]/25 py-5">
        <div className="max-w-3xl mx-auto px-4 flex items-center justify-center gap-2.5">
          <LeafMark className="w-9 h-9" />
          <span className="font-display text-xl font-bold">
            TeaMethod<span className="text-[#D4A359]">.</span>
          </span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-14 sm:py-20 text-center">
        <CheckCircle2 className="w-16 h-16 text-[#D4A359] mx-auto mb-6" strokeWidth={1.5} />
        <h1 className="font-display text-4xl sm:text-5xl font-bold leading-tight" data-testid="thank-you-heading">
          Your ebook is on its way!
        </h1>
        <p className="mt-5 text-base sm:text-lg text-[#FAF7F2]/75 leading-relaxed max-w-xl mx-auto">
          Thank you for your purchase. Hotmart has just sent your access to your email —
          check your inbox (and the spam folder, just in case).
        </p>

        <div className="mt-8 flex items-center justify-center gap-2.5 text-sm text-[#D4A359]" data-testid="thank-you-email-note">
          <Mail className="w-4 h-4" />
          Instant access · Yours forever · 30-day guarantee
        </div>

        <div className="mt-14 bg-[#12261A] border border-[#D4A359]/30 rounded-2xl p-6 sm:p-10 text-left shadow-[0_40px_80px_-30px_rgba(0,0,0,0.6)]">
          <p className="flex items-center gap-2 text-xs font-bold tracking-[0.24em] uppercase text-[#D4A359] mb-2">
            <Sparkles className="w-4 h-4" />
            One-time offer for new readers
          </p>
          <h2 className="font-display text-2xl sm:text-3xl font-bold mb-6">
            Complete your journey with one click
          </h2>
          <div id="hotmart-sales-funnel" data-testid="hotmart-upsell-widget" className="min-h-[120px]" />
        </div>
      </main>

      <footer className="py-8 text-center text-xs text-[#FAF7F2]/40">
        © {new Date().getFullYear()} TeaMethod — The Sustainable Tea &amp; Weight Loss Method
      </footer>
    </div>
  );
}
